import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { questionnaireEvaluationInitializationPostAction, getQuestionnaireEvaluationQuestionnaireQuestionId, questionnaireEvaluationQuestionGetAction, getQuestionnaireEvaluationQustnnrVrsnChng, getQuestionnaireEvaluationQuestionList } from "../../../domain/questionnaireEvaluation";
import { photoCaptureGetAuthenticationDataAction, GPCLoader, getPhotoCaptureWorkItemStatus, getPhotoCaptureQuestionnaireId, getPhotoCaptureUnderWritingCompanyName, getPhotoCaptureIsQuestionnaireUpdated, getPhotoCaptureDisableLibrary, getIsLinkExpired, getIsSessionExpired, getShouldAllowMitchellIntelligent } from "../../../domain/photoCapture";
import { getGPCEvaluationDocId } from '../utilities';
const mapStateToProps = (state) => {
    const questionnaireQuestionId = getQuestionnaireEvaluationQuestionnaireQuestionId(state);
    return {
        evaluationDocId: getGPCEvaluationDocId(state),
        workItemStatus: getPhotoCaptureWorkItemStatus(state),
        questionnaireId: getPhotoCaptureQuestionnaireId(state),
        underWritingCompanyName: getPhotoCaptureUnderWritingCompanyName(state),
        questionnaireQuestionId: questionnaireQuestionId || 0,
        qustnnrVrsnChng: getQuestionnaireEvaluationQustnnrVrsnChng(state),
        isQuestionnaireUpdated: getPhotoCaptureIsQuestionnaireUpdated(state),
        disableLibrary: getPhotoCaptureDisableLibrary(state),
        isLinkExpired: getIsLinkExpired(state),
        isSessionExpired: getIsSessionExpired(state),
        shouldAllowMitchellIntelligent: getShouldAllowMitchellIntelligent(state),
        questionList: getQuestionnaireEvaluationQuestionList(state)
    };
};
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        photoCaptureGetAuthenticationDataAction,
        questionnaireEvaluationInitializationPostAction,
        questionnaireEvaluationQuestionGetAction
    }, dispatch);
};
export const ConnectedGPCLoader = connect(mapStateToProps, mapDispatchToProps)(GPCLoader);
//# sourceMappingURL=ConnectedGPCLoader.js.map